const moduleConfig = {
  newsletters: {
    selector: '.signup',
    elements: {
      email: '.hachette-email',
      input: '.hachette-input',
      list: '.hachette_mailchimp_list_id',
      submit: '.newsletter-submit',
      text: '.newsletter-text',
    },
  },
  mailchimpPopup: {
    selector: '.mailchimp-options',
    elements: {
      groups: '.mailchimp-options__interest-groups li input',
      message: '.mailchimp-options__response-text',
    },
  },
  collapse: {
    selector: '.collapse',
    elements: {
      button: '.collapse-btn',
    },
  },
  notice: {
    selector: '.site',
    elements: {
      button: '.collapse-policy-btn',
    },
  },
  tabs: {
    selector: '.toggled-tabs',
    elements: {
      togglePanel: '.toggled-tabs__item',
      toggleContent: '.toggled-tabs__content',
      tabToggle: '.tablist__item > a',
      accordionToggle: '.panel-title > a',
      accordionHeading: '.panel-heading',
      accordionPanel: '.panel-collapse',
    },
    options: {
      accordionActive: 'panel-heading--active',
    },
  },
  dropdown: {
    selector: '.dropdown',
    elements: {
      dropdownButton: '.dropdown-toggle',
      dropdownMenu: '.dropdown-menu',
    },
  },
  carousel: {
    selector: '.carousel',
    elements: {
      next: '.site-carousel__control--next',
      prev: '.site-carousel__control--prev',
      indicatorWrapper: '.carousel-indicators',
      indicator: '.carousel-indicators li',
      tabPane: '.tab-pane',
      slide: '.item',
      slideItem: '.carousel__slide-content',
      slidesWrapper: '.carousel-inner',
      activeSlide: '.carousel__slide.active',
    },
  },
  swappable: {
    selector: '.swappable',
    elements: {},
  },
  toggle: {
    selector: '.toggleable',
    elements: {},
  },
  truncate: {
    selector: '.truncate',
    elements: {
      toggleTextTruncated: '.toggle-text_truncated',
      toggleTextExpanded: '.toggle-text_expanded',
      toggleBtnTruncated: '.toggle-btn_truncated',
      toggleBtnExpanded: '.toggle-btn_expanded',
    },
  },
  svgAspectRatio: {
    selector: '.aspectRatio',
    elements: {},
  },
  autocomplete: {
    selector: '.site-search__input.add-autocomplete',
    elements: {},
  },
  surpriseme: {
    selector: '.magic-8__inner',
    elements: {
      loadMore: '.magic-8__show-others',
    },
  },
  events: {
    selector: '.events',
    elements: {
      eventsButton: '.events__expand-button',
      activeEvents: '.events__expand-events-list--active',
      slide: '.item',
      eventItem: '.events__item',
    },
  },
  lazyLoadTitles: {
    selector: '.lazy-load-isbn',
    elements: {
      title: '.lazy-load-isbn-title',
      summary: '.lazy-load-isbn-summary',
      link: '.lazy-load-isbn-link',
      cover: '.lazy-load-isbn-cover',
      price: '.lazy-load-isbn-price',
      pubdate: '.lazy-load-isbn-pubdate',
    },
  },
  videoFormat: {
    selector: '.title-featured-video',
    elements: {
      featured: '.title-featured-video__video-wrapper',
      video: '.title-featured-video__video',
    },
  },
  print: {
    selector: '.titles-vertical-list',
    elements: {
      print: '.vertical-titles-print',
      printCont: '.titles-vertical-list',
    },
  },
  countdownclock: {
    selector: '.countdown-clock',
    elements: {
      clock: '.countdown-clock__content',
    },
  },
  map: {
    selector: '.map-module',
    elements: {},
  },
  swiperSlider: {
    selector: '.wp-block-hachette-plugin-slider',
    elements: {
      swiperEl: '.hbg-slider',
      slides: '.hbg-slider__slides',
      liveRegion: '.hbg-slider__live-region',
      pagingList: '.hbg-slider__paging-list',
    },
  },
  brazeHachette: {
    selector: '.site',
    elements: {

    },
  },
  klaviyoHachette: {
    selector: '.site',
    elements: {

    },
  },
};

export default moduleConfig;
